import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getToken, URL, getLocalDate } from "../../utils";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import ConditionalRender from "../../components/ConditionalRender";
import ProspectDegustations from "../../components/ProspectDegustations";
import { getCountryName } from "../../utils/countryUtils";

export default function ProspectDetails() {
  const [currentProspect, setCurrentProspect] = useState(null);
  const { id } = useParams();
  const token = getToken();

  useEffect(() => {
    fetchProspect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProspect = async () => {
    try {
      const [response] = await Promise.all([
        axios.get(`${URL}Prospects/prospect-detail/${id}`, {
          headers: {
            "content-type": "Application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);
      setCurrentProspect(response.data);
      console.log("Données du prospect :", response.data);
    } catch (error) {
      toast.error("Erreur de chargement des données", error);
    }
  };

  return (
    currentProspect && (
      <>
        <ToastContainer />
        <div className="p-4 flex justify-between items-center bg-white m-2 mb-4 rounded-lg shadow-sm">
          <h1 className="text-2xl font-semibold text-slate-700">
            Détails du prospect {currentProspect.nom}
          </h1>

          <div className="flex gap-3">
            <ConditionalRender requiredPermissions="canCreateDegustation">
              <button
                onClick={() => {
                  // Scroll to degustations section and trigger modal
                  const degustationsSection = document.querySelector(
                    '[data-section="degustations"]',
                  );
                  if (degustationsSection) {
                    degustationsSection.scrollIntoView({ behavior: "smooth" });
                    // Trigger the create degustation modal
                    const createButton = degustationsSection.querySelector(
                      'button[data-action="create"]',
                    );
                    if (createButton) {
                      setTimeout(() => createButton.click(), 500);
                    }
                  }
                }}
                className="px-4 py-2 rounded-md bg-green-500 text-white hover:bg-green-600 focus:ring-2 focus:ring-green-400 transition-colors duration-300"
                title="Nouvelle dégustation"
              >
                + Dégustation
              </button>
            </ConditionalRender>

            <ConditionalRender requiredPermissions={"canEditProspect"}>
              <Link
                to={["/prospects/edit/", id].join("")}
                className="px-4 py-2 rounded-md bg-amber-200 text-amber-600 border-2 border-amber-600 hover:text-white hover:bg-amber-600 transition-colors duration-300"
              >
                Modifier
              </Link>
            </ConditionalRender>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-4">
          {/* Carte principale avec les informations essentielles */}
          <div className="lg:col-span-2 bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 text-2xl font-bold mr-4">
                {currentProspect.nom.charAt(0)}
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800">
                  {currentProspect.nom}
                </h2>
                <p className="text-gray-600">
                  {currentProspect.secteur_activite === "night_etablissement"
                    ? "Établissement de nuit"
                    : currentProspect.secteur_activite === "shop"
                      ? "Boutique"
                      : currentProspect.secteur_activite ||
                        "Secteur non spécifié"}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              <div className="space-y-4">
                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">Statut</h3>
                  <div className="mt-1 flex items-center">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                        currentProspect.is_active
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {currentProspect.is_active ? "Actif" : "Inactif"}
                    </span>
                  </div>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">
                    Téléphone
                  </h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {currentProspect.telephone || "Non renseigné"}
                  </p>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">
                    Est une entité
                  </h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {currentProspect.is_entite}
                  </p>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">Poste</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {currentProspect.poste || "Non renseigné"}
                  </p>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">Sexe</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {currentProspect.sexe === "M"
                      ? "Masculin"
                      : currentProspect.sexe === "F"
                        ? "Féminin"
                        : "Non renseigné"}
                  </p>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">Adresse</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {currentProspect.adresse || "Non renseignée"}
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">
                    Qualifié
                  </h3>
                  <div className="mt-1 flex items-center">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                        currentProspect.qualifie === "Oui"
                          ? "bg-green-100 text-green-800"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {currentProspect.qualifie}
                    </span>
                  </div>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">
                    Date de création
                  </h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {getLocalDate(new Date(currentProspect.date_creation))}
                  </p>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">
                    Rendez-vous
                  </h3>
                  <div className="mt-1 flex items-center">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                        currentProspect.rendez_vous === "Oui"
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {currentProspect.rendez_vous}
                    </span>
                  </div>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">
                    Date de rendez-vous
                  </h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {currentProspect.date_rendez_vous
                      ? getLocalDate(new Date(currentProspect.date_rendez_vous))
                      : "Non planifié"}
                  </p>
                </div>

                <div className="border-b pb-3">
                  <h3 className="text-sm font-medium text-gray-500">Pays</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {getCountryName(currentProspect.pays) ||
                      currentProspect.pays ||
                      "Non renseigné"}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-b py-3">
              <h3 className="text-sm font-medium text-gray-500">Commentaire</h3>
              <p className="mt-1 text-lg font-medium text-gray-900">
                {currentProspect.commentaire || "Non renseigné"}
              </p>
            </div>
          </div>

          {/* Carte d'information commerciale */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">
              Information commerciale
            </h2>

            <div className="space-y-6">
              <div>
                <h3 className="text-sm font-medium text-gray-500">
                  Commercial
                </h3>
                <div className="mt-2 flex items-center">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mr-3">
                    {currentProspect.commercial_name
                      ? currentProspect.commercial_name.charAt(0)
                      : "C"}
                  </div>
                  <div>
                    <p className="text-lg font-medium text-gray-900">
                      {currentProspect.commercial_name || "Non assigné"}
                    </p>
                    <p className="text-sm text-gray-500">
                      ID: {currentProspect.commercial}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-sm font-medium text-gray-500">Magasin</h3>
                <p className="mt-1 text-lg font-medium text-gray-900">
                  {currentProspect.magasin_name || "Non assigné"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section des dégustations */}
        <div className="p-4" data-section="degustations">
          <ProspectDegustations
            prospectId={currentProspect.id}
            prospectName={currentProspect.nom}
            magasinId={currentProspect.magasin}
          />
        </div>
      </>
    )
  );
}
